import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

const fromAnyToNonLeadingZeroText = (any) => fromAnyToTrimmed(any).replace(/^0+/, '');

export default fromAnyToNonLeadingZeroText;
